import { CodebookModel } from 'app/shared/model/shared.model';

export interface CaseZoningPlanFilterModel {
  countyCityMunicipality: CodebookModel[];
  zoningPlanType: CodebookModel[];
}

export interface CaseZoningPlanModel {
  zoningPlanIds: number[];
}

export interface CaseZoningPlanViewModel {
  idCaseZoningPlanMap: number;
  idCase: number;
  mark: string;
  name: string
  bulletin: string;
  bulletinNumber: string
  revisionMark: string;
  revisionName: string;
}

export interface CaseZoningPlanComplianceModel {
  compatibilityExplanation: string;
  finalActIssued: boolean;
  hasExistingZoningPlans?: boolean;
}

export const caseZoningPlanFilterInitialData = {
  countyCityMunicipality: [],
  zoningPlanType: []
};

export const zoningPlanComplianceInitialData: CaseZoningPlanComplianceModel = {
  compatibilityExplanation: '',
  finalActIssued: false
};
